import { UiSchema } from '@rjsf/utils'
import { AnyObject } from '@feedyou/utils'
import { BotFeatures } from '@feedyou/schema'

import { useBaseQuestionLikeStepUiSchema } from '../../../../questionLikeSteps/hooks'
import {
  HIDDEN_WIDGET,
  WITHOUT_LABEL,
  useBaseStepUiSchema
} from '../../../../../../features/schema'

export function useFormUiSchema(formData: AnyObject, sdkFeatures: BotFeatures[] = []): UiSchema {
  const uiSchema = {
    ...useBaseStepUiSchema(sdkFeatures),
    ...useBaseQuestionLikeStepUiSchema(sdkFeatures)
  }

  uiSchema.speechContexts = { items: { ...WITHOUT_LABEL, phrases: { items: WITHOUT_LABEL } } }
  return {
    ...adjustUiSchemaToFormDataForCustomPreprocessor(formData)(uiSchema),
    nlpConfigurationId: {
      'ui:options': { mode: 'step' },
      'ui:widget': 'StepNlpConfigSelectWidget'
    }
  }
}

function adjustUiSchemaToFormDataForCustomPreprocessor(formData: AnyObject) {
  return (uiSchema: UiSchema): UiSchema => {
    const preprocessor = uiSchema?.preprocessor || {}
    const isCustomPreprocessorEnabled = formData?.preprocessor?.customPreprocessor?.enabled

    if (isCustomPreprocessorEnabled) {
      const value = { 'ui:widget': 'EditorJavascriptWidget' }
      return { ...uiSchema, preprocessor: { ...preprocessor, value } }
    }

    const previousCustomPreprocessor = preprocessor?.customPreprocessor || {}
    const customPreprocessor = {
      ...previousCustomPreprocessor,
      order: HIDDEN_WIDGET,
      value: HIDDEN_WIDGET,
      format: HIDDEN_WIDGET
    }

    return { ...uiSchema, preprocessor: { ...preprocessor, customPreprocessor } }
  }
}
